import { createApiSlice } from "@common";
import { CRUD_ACTIVITY_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addActivityType",
    method: "post",
    url: CRUD_ACTIVITY_TYPE,
    stateKey: "message",
  },
  {
    name: "getActivityType",
    method: "get",
    url: CRUD_ACTIVITY_TYPE,
    stateKey: "data",
  },
  {
    name: "updateActivityType",
    method: "put",
    url: CRUD_ACTIVITY_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteActivityType",
    method: "delete",
    url: CRUD_ACTIVITY_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"activityType",
 apiConfig, 
 customReducers);
const activityTypeSlice = slice;

export default activityTypeSlice.reducer;

export const {
  addActivityType,
  getActivityType,
  updateActivityType,
  deleteActivityType,
} = thunks;

export const { rowSelect } = actions;
